import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ProofTermsPage } from './proof-terms';

import { PipesModule } from '../../pipes/pipes.module';

@NgModule({
  declarations: [
    ProofTermsPage,
  ],
  imports: [
    IonicPageModule.forChild(ProofTermsPage),
    PipesModule,
  ],
  exports: [
    ProofTermsPage
  ]
})
export class ProofTermsPageModule { }



// WEBPACK FOOTER //
// ./src/pages/proof-terms/proof-terms.module.ts